import React, { useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react';
import { Color } from '../../enums/Color';

interface Props {
    menubar?: boolean,
    value?: string,
    onChange(content:any): void,
    placeholder?: string,
    styles?: any
}

export const TinyEditor: React.FC<Props> = (props) => { 
    // Ref for accessing the editor instance 
    const editorRef = useRef<any>(null); 
    
    const handleImageUpload = (cb: (url: string, data: { title: string }) => void) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/png, image/jpeg');
        input.onchange = () => {
            const file = input.files?.[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    const id = 'blobid' + new Date().getTime();
                    const blobCache = editorRef.current.editorUpload.blobCache;
                    const base64 = (reader.result as string).split(',')[1];
                    const blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
                    cb(blobInfo.blobUri(), { title: file.name });
                };
                reader.onerror = () => { };
                reader.readAsDataURL(file);
            }
        };
        input.click();
    };
      
    return (
        <Editor
            apiKey="rc6oq3ha5cttti4gl67myek3wglvs6zgn1b7oao1khzin62f"
            init={{
                placeholder: props.placeholder,
                branding: false,
                resize: false,
                statusbar: false,
                toolbar_mode: "wrap",
                content_style: `#tinymce, .tox-toolbar { background-color: ${Color.LightAsh} }`,
                height: props.styles && props.styles.height,
                menu: {
                    file: { title: 'File', items: ' print' },
                    edit: { title: 'Edit', items: 'undo redo | cut copy | selectall | searchreplace' },
                    view: { title: 'View', items: ' preview fullscreen' },
                    insert: { title: 'Insert', items: 'image link media | insertdatetime' },
                    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | styles fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat' },
                    tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck' },
                    table: { title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable' },
                    help: { title: 'Help', items: 'help' }
                },
                menubar: props.menubar,
                plugins: "image preview searchreplace fullscreen insertdatetime media table link code lists",
                toolbar: 'fontfamily | fontSize | bold italic strikethrough underline | bullist numlist outdent indent | alignleft aligncenter alignright alignjustify | link unlink | image forecolor | undo redo | code',
                file_picker_types: 'image',
                // custom image picker
                file_picker_callback: handleImageUpload
            }}
            value={props.value}
            onEditorChange={props.onChange}
            onInit={(evt, editor) => {
                editorRef.current = editor; // Store the editor instance in the ref
            }}
        />
    )
}